module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"title":"AI 추천 키워드 안내","description_title":"추천 키워드에 대한 리뷰를 작성해보세요.","description_content":"무슨 내용을 써야 하나 고민하지 말고,\\n추천된 키워드에 대한 내용으로 리뷰를 작성해보세요.\\nAI가 텍스트를 분석해 키워드에 대한 내용인지 판단합니다.","disclaimer":"*AI 분석 시 오차가 발생할 수 있으며, 실제 지급되는 적립금이 달라질 수 있습니다."}}')
  delete Component.options._Ctor
}
